// extracted by mini-css-extract-plugin
export default {"newProjectModal":"css_newProjectModal__d1W8w","title":"css_title__5JNu1","field":"css_field__+fQnP","error":"css_error__u4UT1","buttons":"css_buttons__why2g"};